import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';

/**
 * @typedef {import('../../App.d.ts').ComponentDataPointsTeaserCardsProps} ComponentDataPointsTeaserCardsProps
 * @typedef {import('../../App.d.ts').CardProps} CardProps
 * @typedef {import('../../App.d.ts').CardSectionProps} CardSectionProps
 */
/**
 * @param {CardSectionProps} s
 * @returns {React.js.Element}
 * @constructor
 */
const CardSection = (s) => (
  <>
    {s.title ? <h5 className="dodo-data-points-teaser-card-content__title">{s.title}</h5> : null}
    <span className="dodo-data-points-teaser-card-content__body">{s.body}</span>
  </>
);

/**
 *
 * @param {CardProps} c
 * @returns {React.js.Element}
 * @constructor
 */
const Card = (c) => (
  <div className="dodo-data-points-teaser-card">
    <h3
      className={`dodo-data-points-teaser-card__headline ${
        c.turquoise ? 'dodo-data-points-teaser-card__headline--turquoise' : ''
      }`}
    >
      {c.headline}
    </h3>
    <div className="dodo-data-points-teaser-card__body">
      {c.subheadline ? <h4 className="dodo-data-points-teaser-card__subheadline">{c.subheadline}</h4> : null}
      {c.content.map((s, i) => (
        <CardSection
          key={i}
          {...s}
        />
      ))}
    </div>
  </div>
);

/**
 * @param {ComponentDataPointsTeaserCardsProps} props
 * @returns {Element}
 * @constructor
 */
export default ({
  headline,
  description,
  cards,
}) => (
  <Container>
    <h2>{headline}</h2>
    {description ? <p>{description}</p> : null}
    <div
      data-testid="data-points-teaser-cards"
      className="dodo-data-points-teaser-cards"
    >
      {cards.map((c, i) => (
        <Card
          data-testid="data-points-teaser-card"
          key={i}
          {...c}
        />
      ))}
    </div>
  </Container>
);
